import { supabase } from '../lib/supabase';

interface AuthResult {
  success: boolean;
  error?: string;
}

export const authService = {
  signIn: async (email: string, password: string): Promise<AuthResult> => {
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password
      });

      if (error) {
        if (error.message === 'Invalid login credentials') {
          return { success: false, error: 'Email ou mot de passe incorrect' };
        }
        throw error;
      }

      if (!data.user) {
        return { success: false, error: 'Erreur lors de la connexion' };
      }

      return { success: true };
    } catch (error: any) {
      console.error('Authentication error:', error);
      return { 
        success: false, 
        error: error?.message || 'Une erreur est survenue lors de la connexion'
      };
    }
  },

  signOut: async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
    } catch (error) {
      console.error('Sign out error:', error);
      throw error;
    }
  },

  isAuthenticated: async (): Promise<boolean> => {
    const { data: { session } } = await supabase.auth.getSession();
    return !!session;
  },

  getCurrentUser: () => supabase.auth.getUser(),

  onAuthStateChanged: (callback: (session: any) => void) => {
    return supabase.auth.onAuthStateChange((event, session) => {
      callback(session);
    });
  }
};